import { Graphics } from '@pixi/graphics';
import { CanvasRenderer } from '@pixi/canvas-renderer';
import { Matrix, RenderTexture, Texture } from '@pixi/core';

let canvasRenderer;
const tempMatrix = new Matrix();
Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode, resolution = 1) {
  const bounds = this.getLocalBounds();
  const canvasBuffer = RenderTexture.create({
    width: bounds.width,
    height: bounds.height,
    scaleMode,
    resolution
  });
  if (!canvasRenderer) {
    canvasRenderer = new CanvasRenderer();
  }
  this.transform.updateLocalTransform();
  this.transform.localTransform.copyTo(tempMatrix);
  tempMatrix.invert();
  tempMatrix.tx -= bounds.x;
  tempMatrix.ty -= bounds.y;
  canvasRenderer.render(this, { renderTexture: canvasBuffer, clear: true, transform: tempMatrix });
  const texture = Texture.from(canvasBuffer.baseTexture._canvasRenderTarget.canvas, { scaleMode });
  texture.baseTexture.setResolution(resolution);
  return texture;
};
Graphics.prototype.cachedGraphicsData = [];
Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
  if (this.isMask === true) {
    return;
  }
  this.finishPoly();
  renderer.plugins.graphics.render(this);
};
//# sourceMappingURL=Graphics.mjs.map
